export const PAYPAL_IDENTITY_CONNECTED = "PAYPAL_IDENTITY_CONNECTED";

export default (state = null, action) => {
    switch (action.type) {
        case PAYPAL_IDENTITY_CONNECTED:
            return action.payload;
        default:
            return state;
    }
}
